<template>
  <div>
    <div
      class="content-devx-margin-block"
    >
      <div class="margin-bottom">
        <f7-row>
          <f7-col width="80">
            <f7-block-title>
              {{ $t('Searcher.observations.multimedia_content_title') }}
            </f7-block-title>
          </f7-col>
          <f7-col
            width="20"
            class="text-align-right"
          >
            <AttachFilePopup v-if="!readOnly" />
          </f7-col>
        </f7-row>
      </div>
      <DxDataGrid
        id="MultimediaData-datagrid"
        :data-source="multimedia"
        :remote-operations="true"
        :column-min-width="70"
        :column-auto-width="true"
        :allow-column-resizing="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxSelection
          mode="single"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="MultimediaData"
        />
        <DxPaging :page-size="gridSettings.pageSize" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="pageSizes"
          :show-info="true"
        />
        <DxColumn
          data-field="description"
          :caption="$t('Searcher.observations.description')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="extension"
          :caption="$t('Searcher.observations.file')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field=""
          alignment="center"
          cell-template="download"
          :width="50"
        />
        <DxColumn
          data-field=""
          alignment="center"
          cell-template="delete"
          :width="50"
        />
        <template #download="{ data }">
          <f7-button
            class="dx-btn-pdf"
            raised
            type="default"
            styling-mode="outlined"
            @click="openFile( data.data)"
          >
            <f7-icon
              md="material:file_download"
            />
          </f7-button>
        </template>
        <template #delete="{ data }">
          <f7-button
            class="dx-btn-pdf"
            raised
            type="default"
            styling-mode="outlined"
            :disabled="readOnly"
            @click="removeFile(data.data)"
          >
            <f7-icon
              md="material:clear"
            />
          </f7-button>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxStateStoring,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';

import { Device } from 'framework7/framework7-lite.esm.bundle';
import AttachFilePopup from './attachFilePopup/index.vue';
import settings from '../../../../../js/commonSettings';

export default {
  name: 'MultimediaData',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxStateStoring,
    DxPager,
    DxSelection,
    AttachFilePopup,
  },
  props: {
    multimedia: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageSizes: [5, 10, 20],
    };
  },
  computed: {
    gridSettings() {
      return settings.datagrid;
    },
  },
  methods: {
    openFile(urlFile) {
      if (Device.desktop) {
        const linkSource = urlFile.attachment;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = urlFile.description + urlFile.extension;
        downloadLink.click();
      } else {
        this.downloadForMobile(urlFile);
      }
    },

    checkForReadWritePermissions() {
      const { permissions } = cordova.plugins;
      const list = [
        permissions.READ_EXTERNAL_STORAGE,
        permissions.WRITE_EXTERNAL_STORAGE,
      ];
      permissions.hasPermission(list, success, null);

      function error() {
        this.$f7.dialog.alert(this.$t('PermissionsReadWrite'));
      }

      function success(status) {
        if (!status.hasPermission) {
          permissions.requestPermissions(
            list,
            (status) => {
              if (!status.hasPermission) error();
            },
            error,
          );
        }
      }
    },

    downloadForMobile(urlFile) {
      this.checkForReadWritePermissions();
      const path = `${cordova.file.externalRootDirectory}Download/`;
      const filename = urlFile.description + urlFile.extension;
      const uri = encodeURI(urlFile.attachment);
      const fileTransfer = new FileTransfer();

      fileTransfer.download(
        uri,
        path + filename,
        () => {
          this.$f7.dialog.alert(this.$t('FileDownloadedInDownloads'));
        },
        (error) => {
          if (error.code === 1) {
            this.$f7.dialog.alert(this.$t('PermissionsReadWrite'));
          } else {
            this.$f7.dialog.alert(`Error:${error.code}`);
          }
        },
        false,
        {
          headers: {
            Authorization: 'Basic dGVzdHVzZXJuYW1lOnRlc3RwYXNzd29yZA==',
          },
        },
      );
    },

    ...mapActions('SearcherObservations', ['removeFile']),
  },
};
</script>
<style lang="scss" scoped>
@import './MultimediaData.styles.scss';
</style>
